import { useReadyTrigger, useLogger } from '@booksy-com/vue-tools'

import { useCore } from '@/composables/core/index.js'

const logger = useLogger('deeplinks')

const noop = () => {}

const fallbackService = {
  handle: noop,
  execute: noop,
}

let deeplinksService = null
let readyTrigger = null

export const createDeeplinksService = async () => {
  if (deeplinksService) {
    logger.error('deeplinks service already initialized')
    return
  }

  readyTrigger = useReadyTrigger()
  const { store } = useCore()
  const webView = store.state.app.webView

  if (webView) {
    deeplinksService = await import('./service.js')
      .then(({ deeplinksService }) => deeplinksService)
    readyTrigger.resolveTrigger()
    return
  }

  deeplinksService = fallbackService
  readyTrigger.resolveTrigger()
}

const _deeplinksServiceAction = (action) => {
  if (!readyTrigger) {
    logger.error('deeplinks service not initialized')
    return noop
  }

  return (...args) => readyTrigger?.promise.then(() => {
    return deeplinksService[action](...args)
  })
}

const handle = (uri) => {
  return _deeplinksServiceAction('handle')(uri)
}
const execute = () => {
  return _deeplinksServiceAction('execute')()
}

export const useDeeplinksService = () => {
  return {
    handle,
    execute,
  }
}
